const virtualOutputComponentProvider = require("../../../../../../utils/virtualOutputComponentProvider");
const {apiAdminNuveiReserveList} = require("../../../../../../api/admin/transactions");
const ReserveTableBody = require("./components/ReserveTableBody");
const ReserveTableItem = require("./components/ReserveTableItem");
const React = require("react");
const {initFilter, getFilterParams} = require("../../../../../dumb/IntervalFilterCustom");

const filter$ = initFilter();

module.exports = virtualOutputComponentProvider({
  state: {
    filter: filter$,
  },
  rowHeight: 60,
  request: apiAdminNuveiReserveList,
  getParams: getFilterParams(),
  wrapper(render, setState, self) {
    return (state, props) => {
      return (
        <ReserveTableBody
          self={self}
          filter$={filter$}
          items={render(ReserveTableItem, props)}
          fullSize
        />
      );
    };
  },
});
